module.exports = __webpack_public_path__ + "static/media/gameWarehouse.81cf5cf7.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/qci/atlas/gameWarehouse.png
// module id = 2399
// module chunks = 0